import Component from '../core/component';
import Enhance from '../core/enhance';
import debug from 'debug';
import classnames from 'classnames';
import tools from '../libs/tools';

const log = debug('mobile3.title');


/**
 *
 */
class Title extends Component {
    
    /**
     *
     * @param props
     * @param context
     */
    constructor(props, context) {
        super(props, context);
    }
    
    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        this.changeTitle(this.props)
    }
    
    /**
     *
     * @param nextProps
     */
    componentWillReceiveProps(nextProps) {
        this.changeTitle(nextProps)
    }
    
    /**
     *
     * @param props
     */
    changeTitle(props) {
        if (tools.is_string(props.children) && $('title').html() != props.children) {
            $('title').html(props.children);
            log('change title', props.children)
        }
    }
    
    /**
     *
     * @returns {null}
     */
    render() {
        if (this.props.className) {
            return <div className={classnames('c-title', this.props.className)}>{this.props.children}</div>
        } else {
            return null;
        }
        
    }
}

Enhance(Title, {}, 'Title');
export default Title;
